module.exports = moment;


/*****************
 ** WEBPACK FOOTER
 ** external "moment"
 ** module id = 2
 ** module chunks = 0 1 2
 **/